export function isOnDetailPage(){
    var queryString = window.location.search;
    var controllerName = window.location.pathname;

    var isDetailPage = queryString.indexOf('cId') !== -1 && controllerName === "/getclmdetail";

    return (isDetailPage);
  }

  export function  highlightMatchingText(text,string){
    if (!text) return text;
    let searchResult = text && text.toLowerCase(),query = string && string.toLowerCase().trim();
    if(searchResult.includes(query)){
    var endStr,startStr,middleStr,html;
    if(searchResult.indexOf(query) ==0){
        startStr =text.substring(0,query.length);
        endStr=text.substring(searchResult.indexOf(query)+(query).length,searchResult.length);
        html = '<span class="highlightQuery">' + startStr+ '</span>' + endStr;
        }
    else if((searchResult.indexOf(query)+(query).length) != (searchResult.length)){
        startStr = text.substring(0,searchResult.indexOf(query))
        middleStr=text.substring(searchResult.indexOf(query),searchResult.indexOf(query) + query.length)
        endStr=text.substring(searchResult.indexOf(query)+(query).length,searchResult.length)
        html = startStr+ '<span class="highlightQuery">' + middleStr+  '</span>' + endStr
    }
    else{
        startStr = text.substring(0,searchResult.indexOf(query))
        endStr=text.substring(searchResult.indexOf(query),searchResult.indexOf(query)+query.length);
        html = startStr+ '<span class="highlightQuery">' + endStr+ '</span>';
    }
    return html;
    }
    else{
        return text;
    }    
}
